// extracted by mini-css-extract-plugin
export var closeButton = "_hw-2";
export var closeButtonIcon = "_hw-3";
export var lightboxContent = "_hw-1";
export var lightboxOverlay = "_hw-0";